var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{attrs:{"color":"transparent","flat":""}},[(_vm.message.error)?[_c('div',[_c('v-icon',[_vm._v("mdi-alert")]),_vm._v(" 复制失败 ")],1),_c('div',[_vm._v(_vm._s(_vm.message.error.message))])]:_c('div',[_vm._v("复制成功，新建一个txt文件粘贴进去即可用来导入")])],2)
}
var staticRenderFns = []

export { render, staticRenderFns }